module.exports = __webpack_public_path__ + "img/about_2.eeddc029.svg";